import { render, staticRenderFns } from "./dealerOrderDetail.vue?vue&type=template&id=2b149698&scoped=true&"
import script from "./dealerOrderDetail.vue?vue&type=script&lang=js&"
export * from "./dealerOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./dealerOrderDetail.vue?vue&type=style&index=0&id=2b149698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b149698",
  null
  
)

export default component.exports